import imageTypes from '../constants/imageTypes';

import baseService from './baseService';

export const uploadProfileImage = (file, type, userId) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();

  const updatedData = {
    ...data,
    user: {
      [type === 'user_avatar' ? 'avatar_attributes' : 'cover_image_attributes']: {
        image_type: imageTypes[type],
        image: file[0],
      },
      is_linkedin_picture_exists: false,
    },
  };

  return baseService.patch(`/member/users/${userId}`, updatedData, config);
};

export const deleteCoverImage = (imageId) => baseService.delete(`/member/images/${imageId}`);

export const updateUserProfile = (userId, data) => baseService.patch(`/member/users/${userId}`, { user: data });

export function uploadLinkedinPDF(file) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  data.append('file', file);
  return baseService.post(`/member/linkedin`, data, config);
}

export function fetchLinkedinProfile(url) {
  return baseService.get(`/member/linkedin_profile_import`, {
    params: {
      linkedin_url: url,
    },
  });
}

export const updatePassword = (userId, oldPassword, newPassword) =>
  baseService.patch(`/member/passwords/${userId}`, {
    password: oldPassword,
    new_password: newPassword,
  });

export const getUserDetails = (userId) => baseService.get(`/member/users/${userId}`);

export const getURLProfileDetails = (url) =>
  baseService.get(`/member/users/url_base_user`, {
    params: {
      personal_url: url,
    },
  });

export const createOrganizationAccessRequest = (data) => baseService.post('/users/organization_access_requests', data);

export const closeAccount = (userId, userPassword, closureReasons, otherReason) =>
  baseService.delete(`/member/users/${userId}`, {
    params: {
      password: userPassword,
      closure_reasons: closureReasons,
      other_reason: otherReason,
    },
  });
export const getEmails = (userId) => baseService.get('/member/emails', { params: { user_id: userId } });

export const updatePrimaryEmail = (id, password, userId) =>
  baseService.patch(`/member/emails/${id}`, {
    password,
    primary: true,
    user_id: userId,
  });

export const verifyAdditonalEmail = (email, userId) =>
  baseService.patch(`/member/emails/-1`, {
    verify_email: true,
    user_id: userId,
    email,
  });

export const createEmail = (userId, email) => baseService.post('/member/emails', { email, user_id: userId });

export const deleteEmail = (id) => baseService.delete(`/member/emails/${id}`);

export const getExperientialRewardDetails = () => baseService.get('/member/experiential_reward_payment_details');

export const postExperientialRewardDetails = (address) =>
  baseService.post('/member/experiential_reward_payment_details', {
    details: { ...address },
  });

export const updateExperientialRewardDetails = (address) =>
  baseService.patch('/member/experiential_reward_payment_details', {
    details: { ...address },
  });
